const MAX_EMAIL_LENGTH = 254;
const MAX_LOCAL_LENGTH = 64;
const MAX_DOMAIN_LENGTH = 253;

export function normalizeEmailAddress(email) {
  return String(email || "").trim().toLowerCase();
}

/** Same rules as backend/emailPolicy.js — keep in sync. */
export function isValidEmailAddress(email) {
  const s = normalizeEmailAddress(email);
  if (!s || s.length > MAX_EMAIL_LENGTH) return false;

  const parts = s.split("@");
  if (parts.length !== 2) return false;

  const local = parts[0];
  const domain = parts[1];

  if (!local || local.length > MAX_LOCAL_LENGTH) return false;
  if (local.startsWith(".") || local.endsWith(".") || local.includes("..")) {
    return false;
  }
  if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return false;

  if (!domain || domain.length > MAX_DOMAIN_LENGTH) return false;
  if (!domain.includes(".")) return false;
  if (domain.startsWith(".") || domain.endsWith(".") || domain.includes("..")) {
    return false;
  }

  const labels = domain.split(".");
  if (labels.length < 2) return false;
  for (const label of labels) {
    if (!label || label.length > 63) return false;
    if (label.startsWith("-") || label.endsWith("-")) return false;
    if (!/^[a-z0-9-]+$/.test(label)) return false;
  }

  const tld = labels[labels.length - 1];
  if (tld.length < 2) return false;

  return true;
}
